/* F&P V10 "Fluid store": small shared behaviours for every page (module, no dependencies).
   1. Film pause buttons ([data-fp-film-pause] next to an <fp-v9-film>): every self-moving film can be paused.
   2. Grid hover, all or none per visual row (owner, S217): in collection/search grids a card only crossfades to its
      second photo when every card in its row has one; recomputed after filters, resizes and new pages.
   3. A card whose swatch shows another colour stops crossfading (its hover photo is of the first colour). */
const reduce = matchMedia('(prefers-reduced-motion: reduce)');

document.addEventListener('click', (event) => {
  const btn = event.target.closest('[data-fp-film-pause]');
  if (!btn) return;
  const film = btn.closest('figure, li, section')?.querySelector('fp-v9-film');
  if (!film) return;
  const paused = btn.getAttribute('aria-pressed') !== 'true';
  film.hold?.(paused);
  btn.setAttribute('aria-pressed', String(paused));
  btn.classList.toggle('is-paused', paused);
  btn.setAttribute('aria-label', paused ? 'Play the film' : 'Pause the film');
});
if (reduce.matches) document.querySelectorAll('[data-fp-film-pause]').forEach((btn) => { btn.hidden = true; });

/* ---------- grid hover rows ---------- */
const gridHover = () => {
  document.querySelectorAll('main .product-grid').forEach((grid) => {
    const cards = [...grid.querySelectorAll(':scope > .product-grid__item[ref="cards[]"]')];
    const rows = new Map();
    for (const card of cards) {
      const top = Math.round(card.getBoundingClientRect().top / 8); // same row within a few pixels
      if (!rows.has(top)) rows.set(top, []);
      rows.get(top).push(card);
    }
    for (const row of rows.values()) {
      const all = row.every((c) => c.querySelector('.fp-card-hover'));
      row.forEach((c) => c.toggleAttribute('data-fp-row-hover-off', !all));
    }
  });
};
let queued = false;
const schedule = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; gridHover(); }); };
if (document.querySelector('main .product-grid')) {
  schedule();
  addEventListener('resize', schedule, { passive: true });
  const main = document.querySelector('main');
  new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
  addEventListener('load', schedule, { once: true });
}

/* ---------- swatches on a card ---------- */
document.addEventListener('change', (event) => {
  const picker = event.target.closest('product-card swatches-variant-picker-component, product-card .variant-picker');
  if (!picker) return;
  const card = picker.closest('product-card');
  const first = card.dataset.fpFirstColour ?? (card.dataset.fpFirstColour = event.target.defaultValue || '');
  card.toggleAttribute('data-fp-hover-off', event.target.value !== first);
});
